import { Params, RouterStateSnapshot } from "@angular/router";
import { RouterStateSerializer } from "@ngrx/router-store";

export interface RouterState {
  url: string;
  params: Params;
  queryParams: Params;
  data: any[];
}

export class RouterSerializer implements RouterStateSerializer<RouterState> {
  serialize(routerState: RouterStateSnapshot): RouterState {
    let route = routerState.root;
    let params = {};
    const data = [];
    while (route.firstChild) {
      route = route.firstChild;
      params = {
        ...params,
        ...route?.params,
      };
      if (
        route?.data &&
        Object.keys(route?.data)?.length > 0 &&
        !data.some((obj) => JSON.stringify(obj) === JSON.stringify(route.data))
      ) {
        data.push(route?.data);
      }
    }

    const {
      url,
      root: { queryParams },
    } = routerState;
    return { url, params, queryParams, data: data };
  }
}
